<template>
    <div class="wrapper flex fd-c ai-c">
        <div class="head flex ai-c jc-sb">
            <logo :Index="Index" />
            <div class="type">
                <template v-if="$route.query.id==0">
                    H5案例
                </template>
                <template v-if="$route.query.id==1">
                    动画案例
                </template>
                <template v-if="$route.query.id==2">
                    插画案例
                </template>
                <template v-if="$route.query.id==3">
                    品宣案例
                </template>
            </div>
        </div>
        <div class="detail flex fd-c ai-c">
            <div class="title">{{details.name}}</div>
            <div class="fwb" v-html="details.detailHtml"></div>
            
        </div>
    </div>
</template>

<script>
import { getDetails } from '../../../../api'
import logo from "../../logo.vue";
import wx from 'weixin-js-sdk'
export default {
    components: {
        logo,
        
    },
    props: {},
    data() {
        return {
            timer: null,
            Index: 0,
            details: {}
        };
    },
    watch: {},
    computed: {},
    methods: {
        
        getDetails() {
            getDetails(this.$route.query.id).then(res=>{
                var data = res.data.data
                data.detailHtml = data.detailHtml.replace(/img.xiumi.us/g, 'case.chinawans.com/file/image')
                // data.detailHtml = data.detailHtml.replace(/src=/g, `onload='
                // console.log(111)
                // function getBase64Image(img) {
                //      var canvas = document.createElement("canvas");
                //     canvas.width = img.width;
                //     canvas.height = img.height;
                //     var ctx = canvas.getContext("2d");
                //     ctx.drawImage(img, 0, 0, img.width, img.height);
                //     var ext = img.src.substring(img.src.lastIndexOf(".")+1).toLowerCase();
                //     var dataURL = canvas.toDataURL("image/"+ext);
                //     return dataURL;
                // }
               
                //  var tempImage = new Image();
                //   tempImage.src = this.src
                //   tempImage.crossOrigin = "*";
                //    tempImage.onload = ()=>{
                //       var base64 = getBase64Image(tempImage)
                //       this.src=base64
                //       this.onload=null
                //       this.onload=null
                //    }
                 
                // ' src=`)
                // data.detailHtml = this.changePhoto(data.detailHtml)
                this.details = data
                wx.ready(() => {
                    var obj = {
                        title: res.data.data.name, // 分享标题
                        desc: '历史不可复制，破局者得以生存', // 分享描述
                        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: 'http://case.chinawans.com/img/share.jpg', // 分享图标
                        success: function () {
                        // 设置成功
                        }
                    }
                    // wx.hideOptionMenu();
                    wx.updateAppMessageShareData(obj)
                    wx.updateTimelineShareData(obj)
                })
            })
        },
        changePhoto (data) {
            var that = this
            let result = data.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
                return match
            })
            console.log(result);
            // let result = data.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
            // var imgLink = capture;
            // var tempImage = new Image();
            // tempImage.src = imgLink;
            // tempImage.crossOrigin = "*";
            // tempImage.onload = ()=>{
            //     var base64 = that.getBase64Image(tempImage);
            //     match = '<img src=' + base64 + ' title="01.png" alt="01.png" style="max-width:890px" class="cpImg"/>';
            //    console.log(match);
            //    return match
            // }
            // // match = '<img src=' + url.imgUrl + capture + ' title="01.png" alt="01.png" style="max-width:890px" class="cpImg"/>';
            
            // });
            data = result
            return data
        },
        getBase64Image(img) {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, img.width, img.height);
            var ext = img.src.substring(img.src.lastIndexOf(".")+1).toLowerCase();
            var dataURL = canvas.toDataURL("image/"+ext);
            return dataURL;
        }
    },
    created() {
        this.timer = setInterval(() => {
            this.Index++;
        }, 50);
        this.getDetails()
    },
    mounted() {
        
    },
    destroyed() {
        clearInterval(this.timer);
    },
};
</script>
<style scoped>
.wrapper {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url(../../../../assets/images/bg.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-color: rgba(29, 29, 29, 1);
}
.head {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 1.29rem;
    background-color: #343434;
}
.detail {
    width: 100%;
    height: calc(100vh - 1.29rem);
    overflow-y: auto;
    padding-bottom: .5rem;
    box-sizing: border-box;
    padding: 0 .3rem;
}
.detail .title{
    width: 6.25rem;
    font-size: .39rem;
    font-family: PingFangSC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: .64rem;
    margin-top: .85rem;
}
.detail .fwb{
    width: 100%;
    margin-top: .3rem;
    padding-bottom: 1rem;
}
.detail .fwb>>>*{
    max-width: 100%!important;
    /* font-size: .28rem!important; */
    /* color: #fff!important; */
    /* text-align: justify!important; */
    /* white-space: pre-line!important; */
    /* background-color: transparent!important; */
}
.detail .fwb>>>img{
    max-width: 100%!important;
    height: auto!important;
}
.detail .fwb>>>video{
    height: 4rem!important;
    background-color: #000;
}
.type{
    font-size: .38rem;
    margin-right: .55rem;
    font-family: PingFangSC;
    font-weight: 200;
    color: rgba(255, 255, 255, .51);
}
</style>